import { Label, TextField } from "@towersystems/roam-common-native";
import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { AddCartNonMatchingProductFormValues } from "../types";
import { useTranslation } from "../../../../../utilities/i18n";

export interface TaxRateFormInputProps {}

export const TaxRateFormInput = ({}: TaxRateFormInputProps) => {
  const { control } = useFormContext<AddCartNonMatchingProductFormValues>();
  const { t } = useTranslation("pos");

  return (
    <View>
      <Label label={t("form.taxRate.label")}></Label>
      <Controller
        name="taxRate"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            value={value}
            onChangeText={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.taxRate.placeholder")}
            keyboardType="numeric"
          />
        )}
      />
    </View>
  );
};
